import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";
import { escapeHtml, truncateTitle, utilizationLabelsHtml, NO_IMAGE_PATH } from "src/site/sample_card";

// Site::PrefectureArea::UseCaseSection::Component の Stimulus コントローラ。
// landIeul: UseCaseSection の useQuery(GetUseExamplesByPrefectureAndKind) をクライアント fetch で再現し、
// Home::Samples::Examples と同じ Example_* カードを組む。0 件なら section を出さない (hidden のまま)。
const QUERY = `query GetUseExamplesByPrefectureAndKind($prefectureId: ID!, $kind: ID!, $limit: Int){
  useExamplesByPrefectureAndKind(prefectureId: $prefectureId, kind: $kind, limit: $limit){
    id title brandLandUtilizationMethods brand { id name } firstImage { thumbnailUrl }
  }
}`;

interface UseExample {
  id: string;
  title: string;
  brandLandUtilizationMethods: string[];
  brand: { id: string; name: string };
  firstImage?: { thumbnailUrl?: string } | null;
}

class SitePrefectureAreaUseCaseSectionController extends Controller<HTMLElement> {
  static targets = ["wrapper"];
  static values = { graphql: String, prefectureId: String, kind: String, limit: Number };

  declare readonly wrapperTarget: HTMLElement;
  declare readonly graphqlValue: string;
  declare readonly prefectureIdValue: string;
  declare readonly kindValue: string;
  declare readonly limitValue: number;

  connect(): void {
    void this.load();
  }

  private async load(): Promise<void> {
    const res = await fetch(this.graphqlValue, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        query: QUERY,
        variables: {
          prefectureId: this.prefectureIdValue,
          kind: this.kindValue,
          limit: this.limitValue,
        },
      }),
    });
    const json = await res.json();
    const examples: UseExample[] = json?.data?.useExamplesByPrefectureAndKind || [];
    if (examples.length === 0) return;

    this.wrapperTarget.innerHTML = examples.map((e, i) => this.cardHtml(e, i)).join("");
    this.element.hidden = false;
  }

  private cardHtml(example: UseExample, index: number): string {
    const imageUrl = example.firstImage?.thumbnailUrl || NO_IMAGE_PATH;
    const alt = `${example.brand.name} ${example.title} の建築事例・施工イメージ${index + 1}`;
    const link = `/company/${example.brand.id}/examples/${example.id}/`;
    return `<a href="${escapeHtml(link)}" class="Example_card">
  <div class="Example_inner">
    <div class="Example_image">
      <img alt="${escapeHtml(alt)}" loading="lazy" decoding="async" sizes="100vw" src="${escapeHtml(imageUrl)}" style="position:absolute;height:100%;width:100%;left:0;top:0;right:0;bottom:0;object-fit:cover;color:transparent">
    </div>
    <h3 class="Example_title">${escapeHtml(truncateTitle(example.title))}</h3>
    <div class="Example_content">
      <div class="Example_row">
        <p class="Example_utilizationColumn">活用法：${utilizationLabelsHtml(example.brandLandUtilizationMethods)}</p>
      </div>
      <div class="Example_row">
        <p class="Example_brand">${escapeHtml(example.brand.name)}</p>
      </div>
    </div>
  </div>
</a>`;
  }
}

application.register(
  "site--prefecture-area--use-case-section",
  SitePrefectureAreaUseCaseSectionController,
);
